import { useMutation, useQueryClient } from "@tanstack/react-query";

import { enrollmentRequest } from "@/apiQueries/multisigEnrollment/multisigEnrollmentRequest";
import {
  MULTISIG_ENROLLMENT_QUERY_KEY,
  MULTISIG_ENROLLMENT_URL,
} from "@/apiQueries/multisigEnrollment/useMultisigEnrollment";

import type { EnrollmentError } from "@/helpers/enrollmentErrors";

import type { MultisigEnrollmentSession } from "@/types";

/** `POST /multisig/enrollment`. Starts an enrollment session with the chosen second Owner (201). */
export const useMultisigEnrollmentInitiate = () => {
  const queryClient = useQueryClient();

  return useMutation<MultisigEnrollmentSession, EnrollmentError, { owner2UserId: string }>({
    mutationFn: (vars: { owner2UserId: string }) =>
      enrollmentRequest<MultisigEnrollmentSession>(MULTISIG_ENROLLMENT_URL, {
        method: "POST",
        body: JSON.stringify({ owner2_user_id: vars.owner2UserId }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: MULTISIG_ENROLLMENT_QUERY_KEY }),
  });
};
